import { Box, Grid } from '@material-ui/core';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';

import { SETVIImage, SText } from '@setvi/shared/components';
import { resourceView } from '@setvi/shared/utils/viewer';

import { AskPdfProps } from 'componentsV2/ai/modules/ask-pdf';

import { Container, Item, PDFName, ScrollableGrid, TitleBox } from './styled';
import AITextarea from '../textarea';

interface PlaceholderProps extends Partial<AskPdfProps> {
  onClick: (q: string) => void;
  questions: string[];
}

const Placeholder = ({
  id,
  name,
  typeId,
  thumbnail,
  questions,
  onClick
}: PlaceholderProps) => (
  <Container>
    <SETVIImage
      radius={8}
      width={180}
      height={180}
      src={thumbnail}
      alt="PDF thumbnail"
      style={{
        border: `1px solid #d1cfcf`,
        boxShadow: '0px 3px 8px rgba(0, 0, 0, 0.2)'
      }}
    />

    <TitleBox>
      <SText
        size="xl"
        weight="medium"
        title="Some Frequently asked questions about"
      />

      <PDFName
        onClick={() =>
          resourceView({
            name,
            resourceTypeId: typeId,
            resourceId: id
          })
        }>
        <SText size="xl" weight="medium" title={name} maxWidth={350} />
        <OpenInNewIcon color="primary" />
      </PDFName>
    </TitleBox>

    <Box
      style={{
        gap: 8,
        width: '60%',
        display: 'flex',
        flexDirection: 'column',
        alignContent: 'center',
        justifyContent: 'center'
      }}>
      <AITextarea onSubmit={onClick} width="100%" />

      <ScrollableGrid container spacing={1}>
        {questions.map(q => (
          // Add here grid that for lg will pe xs 6 other will be 12
          <Grid item xs={12} lg={6} key={q}>
            <Item onClick={() => onClick(q)}>{q}</Item>
          </Grid>
        ))}
      </ScrollableGrid>
    </Box>
  </Container>
);

export default Placeholder;
